import React, {Fragment} from "react";
import {useSelector} from "react-redux";
import {ParameterComponent} from "../Components/Pages/ReportBuilder";
import {ReportSections} from "../Components/Pages/ReportBuilder";
import {service as ReportService} from "../Services/ReportService";
import {PhotoMonitoringReport} from "../Components/Pages/ReportBuilder";

export const useReportPages = () => {
    const projectReportPages = useProjectReportPages();
    const sampleEventPages = useSampleEventPages();

    const {reportTypes, reportTypeId} = useSelector(state => state.reportState);

    const currentReportType = reportTypes.find(type => Number(type.reportTypeId) === Number(reportTypeId));

    switch (currentReportType?.code) {
        case 'project-annual':
            return projectReportPages;
        case 'monitoring-event':
            return sampleEventPages;
        default:
            return [{component: <ParameterComponent />}];
    }
};

export const useProjectReportPages = () => {
    const {projectId, phases, phaseId, selectedSections} = useSelector(state => state.reportState);

    const currentPhase = phases?.find(phase => Number(phase.sampleEventPhaseId) === Number(phaseId));
    const procedureCodes = [...selectedSections['riparian-habitat'] ?? [], ...selectedSections['instream-habitat'] ?? []];

    return [
        {
            component: (
                <Fragment>
                    <ParameterComponent />
                    <ReportSections />
                </Fragment>
            ),
            actions: [
                {
                    label: 'Generate Report (.docx)',
                    onPress: () => {
                        ReportService.Print(projectId, currentPhase?.code, procedureCodes);
                    },
                    disabled: !projectId || !phaseId || (!procedureCodes.length),
                }
            ]
        },
    ];
};

export const useSampleEventPages = () => {
    const {projectId, project, phaseId, currentEvent, procedures, procedureId, monitoringEventId, photosLoaded } = useSelector(state => state.reportState);

    const currentProcedure = procedures?.find(procedure => Number(procedure.procedureId) === Number(procedureId));
    let procedureComponent;

    //const procedure = procedures?.find( p => p.procedureId === procedureId );
    //const currentEvent = currentProcedure?.SampleEvents?.find( se => String(se.sampleEventId) === String(monitoringEventId) );

    switch (currentProcedure?.code) {
        case 'photo':
            procedureComponent = <PhotoMonitoringReport  />;
            break;
        default:
            procedureComponent = null;
    }

    return [
        {
            component: <ParameterComponent />,
            nextButtonDisabled: !projectId || !procedureId || !monitoringEventId || !procedureComponent
        },
        {
            title: 'Photo Point Monitoring Report',
            component: procedureComponent,
            colSize: 12,
            actions: [
                {
                    label: photosLoaded ? 'Print' : 'Loading...',
                    onPress: () => {
                        document.title = `${project.name} - ${currentEvent?.shortName} - Photo Point Report`;
                        window.print();
                    },
                    disabled: !photosLoaded
                },
                {
                    label: 'Download (.zip)',
                    onPress: () => {
                        ReportService.DownloadPhotos(projectId, [currentEvent?.sampleEventId]);
                    },
                    disabled: !projectId || !currentEvent?.sampleEventId,
                }
            ]
        }
    ];
};
